import React from "react";
import { MdWarning } from "react-icons/md";
import { t } from "i18next";


const WarningIcon = () => (
  <MdWarning className="w-16 h-16 text-warning" />
);

export const getWarningDialogProps = (props) => ({
  className: "border-t-4 border-warning-hover",
  titleClassName: "text-warning-hover",
  textClassName: "text-warning",
  image: props.image || <WarningIcon />,
  buttons: props.buttons || [
    {
      text: t("general.buttons.confirm"),
      variant: "secondary",
    },
  ],
  ...props,
});

export default WarningIcon;
